import axiosInstance from "./axiosConfig";

export const getAboutUsData = async () => {
  try {
    const response = await axiosInstance.get("/laptops/about-us");
    return { success: true, data: response.data.data };
  } catch (error) {
    console.error("Error fetching About Us data:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to fetch About Us data",
    };
  }
};
